import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LayoutComponent } from './layout/layout/layout.component'
import { LoginComponent } from './login/components/login.component'
import { AuthGuard } from './login/auth/auth.guard'
import { AgentLinkComponent } from './login/agent-link/agent-link.component'
import { ToastService } from './service/toast/toast.service'
import { CommonModule } from '@angular/common'
import { AgentForgotPasswordComponent } from './login/agent-forgot-password/agent-forgot-password.component'

const routes: Routes = [
  { path: 'main', canActivate: [AuthGuard], component: LayoutComponent },
  { path: 'login', component: LoginComponent },
  { path: 'newagent/:email/:code', component: AgentLinkComponent },
  { path: 'lostpassword/:email/:code', component: AgentForgotPasswordComponent },
  { path: '', redirectTo: '/main/general', pathMatch: 'full' },
]

@NgModule({
  imports: [RouterModule.forRoot(routes), CommonModule],
  exports: [RouterModule],
  providers: [ToastService],
})
export class AppRoutingModule {}
